import styled from 'styled-components';
import { Accordion } from 'react-rainbow-components';

export default styled(Accordion)`
    li {
        border: none;
        box-shadow: none;
    }
`;
